export default __webpack_public_path__ + "static/media/degen.aed42535.svg";